import { Badge } from "@bcc/components/ui/badge";
import { cn } from "@bcc/lib/utils";

interface OrdersCountBadgeProps {
  /** Number of waiting-to-be-fulfilled orders */
  readonly count?: number;
  readonly className?: string;
  readonly testId?: string;
}

/**
 * Small badge showing the count of orders waiting to be fulfilled for a carrier.
 * Returns null when count is 0 or undefined.
 */
export function OrdersCountBadge({ count, className, testId }: OrdersCountBadgeProps) {
  if (!count) return null;

  return (
    <Badge
      data-testid={testId}
      variant="secondary"
      className={cn("ml-auto h-5 min-w-5 justify-center rounded-full bg-red-600 px-1.5 text-xs font-semibold text-white", className)}
    >
      {count}
    </Badge>
  );
}
